export enum ETouchTriggerNotSentReason {
  CampaignInactive = 'CAMPAIGN_INACTIVE', // Campaign wasn't active at the time the touch was processed
  MarketingProfileIncomplete = 'MARKETING_PROFILE_INCOMPLETE', // User's marketing profile was incomplete at the time the touch was processed
}
